import React from "react";

function auto(){
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z" stroke="#BABEC3" stroke-width="1.5"/>
  <path d="M8 16.5L9.59412 12.1162M9.59412 12.1162L11.5171 6.82792C11.6761 6.39069 12.2945 6.39069 12.4535 6.82792L14.3765 12.1162M9.59412 12.1162H14.3765M14.3765 12.1162L15.9706 16.5" stroke="#BABEC3" stroke-width="1.5" stroke-linecap="round"/>
</svg>
    )
}
export default auto;